<script setup lang="ts">
withDefaults(defineProps<{
  debug?: boolean
}>(), { 
  debug: false,
})
</script>

<template>
<Frame class="m-frame frame-icon-statement" :class="{ debug }" 
w="grid grid-cols-[1fr] g-2 d:g-0 t:grid-cols-[100px_1fr] mw-96 mx-auto">
  <Frame class="col-icon" w="col-clamp">
    <slot name="icon">
      icon
    </slot>
  </Frame>
  <Frame class="col-statement" w="col-clamp">
    <slot name="statement">
      statement
    </slot>
  </Frame>
</Frame>
</template>

<style lang="scss" scoped>
.m-frame {
  &.frame-icon-statement {

    .col-icon {
      
    }

    .col-statement {
      
    }

  }

  &.debug {
    box-shadow: inset 0 0 0 1px red;

    :deep(>.m-wrap) {
      box-shadow: inset 0 0 0 1px blue;

      .col-1 {
        box-shadow: inset 0 0 0 1px green;
        >.m-wrap {
          box-shadow: inset 0 0 0 1px pink;
        }
      }
      .col-2 {
        box-shadow: inset 0 0 0 1px orange;
        >.m-wrap {
          box-shadow: inset 0 0 0 1px purple;
        }
      }
    }
  }
}
</style>